// src/modules/notifications.js
//
// Notifications module manifest.
// Controls: NotificationOverlay, NotificationsLibrary routes, alert stores.

export default {
  id: 'notifications',
  label: 'Notifications',

  stores: {
    notificationTriggersStore: {
      import: () => import('@/stores/notificationTriggersStore'),
      storeId: 'notificationTriggersStore',
      init: store => {
        store.fetchTriggers()
      },
      cleanup: () => {
        /* static data */
      },
    },
    noteNotificationStore: {
      import: () => import('@/stores/noteNotificationStore'),
      storeId: 'noteNotificationStore',
      init: store => {
        store.subscribe()
      },
      cleanup: store => {
        store.unsubscribe?.()
      },
    },
    commsNotificationStore: {
      import: () => import('@/stores/commsNotificationStore'),
      storeId: 'commsNotificationStore',
      init: store => {
        store.subscribe()
      },
      cleanup: store => {
        store.unsubscribe?.()
      },
    },
    dashboardStore: {
      import: () => import('@/stores/dashboardStore'),
      storeId: 'dashboardStore',
      init: store => {
        store.subscribe()
      },
      cleanup: store => {
        store.unsubscribe?.()
      },
    },
  },

  globalComponents: {
    NotificationOverlay: () => import('@/components/Notifications/NotificationOverlay.vue'),
  },

  routes: ['NotificationsLibrary', 'NotificationNew', 'NotificationEdit'],

  nav: [{ label: 'Automations', routeName: 'NotificationsLibrary', group: 'tools' }],
}
